module.exports = __webpack_public_path__ + "5fc89d3e.png";